import { render, staticRenderFns } from "./OrderTimer.vue?vue&type=template&id=2c58cf03&scoped=true&"
import script from "./OrderTimer.vue?vue&type=script&lang=js&"
export * from "./OrderTimer.vue?vue&type=script&lang=js&"
import style0 from "./OrderTimer.vue?vue&type=style&index=0&id=2c58cf03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58cf03",
  null
  
)

export default component.exports